<template>
  <div class="container">
    <div>{{ message }}</div>
    <div v-if="showNum">行号：{{ result }}</div>
    <div v-else>{{ result }}</div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'UploadTemplateMessage',
  props: {
    message: {
      type: String,
      required: true,
      default: ''
    },
    result: {
      type: String,
      required: true,
      default: ''
    },
    showNum: {
      type: Boolean,
      default: true
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  word-break: break-all;
  text-align: left;
}
</style>
